import ImageView from '@/components/ImageView/ImageView.vue';
import ModalDisplay from '@/components/Modal/ModalDisplay.vue';
import { computed, defineComponent, ref } from '@vue/composition-api';
import LoadingSpinner from '@/components/Loaders/LoadingSpinner.vue';
import { Icon, IconSize } from '@/components/Icon';
import { mdiTrayArrowDown } from '@mdi/js';
import api from '@/api/v2';
export default defineComponent({
    components: {
        LoadingSpinner,
        ModalDisplay,
        ImageView,
        Icon,
    },
    props: {
        imageUrl: {
            type: String,
            default: null,
        },
        alt: {
            type: String,
            required: true,
        },
        fullHeight: {
            type: Boolean,
            default: true,
        },
        fullWidth: {
            type: Boolean,
            default: false,
        },
        zIndex: {
            type: Number,
            default: 10000,
        },
        showDownloadButton: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const showModal = ref(false);
        const imgLoaded = ref(false);
        const isDownloading = ref(false);
        const classNames = computed(() => {
            return { 'h-full': props.fullHeight, 'w-full': props.fullWidth };
        });
        const modalStyle = computed(() => ({
            zIndex: props.zIndex,
        }));
        const downloadImage = async () => {
            if (isDownloading.value)
                return;
            isDownloading.value = true;
            try {
                const response = await api({
                    method: 'GET',
                    url: props.imageUrl,
                    responseType: 'blob',
                });
                const blob = response.data;
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `image-${Date.now()}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
            catch (error) {
                console.error(error);
            }
            finally {
                isDownloading.value = false;
            }
        };
        return {
            showModal,
            imgLoaded,
            isDownloading,
            classNames,
            modalStyle,
            downloadImage,
            mdiTrayArrowDown,
            IconSize,
        };
    },
});
